import ICON__users_gear_solid from '@/assets/icons/font_awesome/users-gear-solid.svg?react';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { PLACEHOLDER_BUTTON__bar_10_5 } from '../buttons/PLACEHOLDER_BUTTON__bar_10_5';
import { HARDWARE_STATS__master } from '../hardware_performance/HARDWARE_STATS__master';
import { LAYOUT_COLUMN__right } from '../layout_base/LAYOUT_COLUMN__right';
import { BUTTON__navigation_desktop } from '../sidebar_navigation/desktop/BUTTON__navigation_desktop';
import { LABEL__workspace_balance } from './LABEL__workspace_balance';

export function FOOTER__column_right_default() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { is_authorized, user_role, user_settings } = use_slice_user(['is_authorized', 'user_role', 'user_settings']);

  /*
   * RENDERS
   */
  function render_buttons_settings() {
    if (!is_authorized) return <PLACEHOLDER_BUTTON__bar_10_5 />;

    return (
      <>
        <BUTTON__navigation_desktop
          page_type={ENUM__page_type.SETTINGS_WORKSPACE_WITHOUT_PARAMS}
          tooltip_title={t(i18n_base_ui.sidebar_navigation.tabs.settings_workspace.tooltip.title)}
          title={t(i18n_base_ui.sidebar_navigation.tabs.settings_workspace.title)}
          Icon={ICON__users_gear_solid}
          disabled={!is_authorized}
        />
      </>
    );
  }

  /*
   * HTML
   */

  return (
    <LAYOUT_COLUMN__right>
      <div className="flex flex-col size-full">
        <div className="flex flex-row w-full flex-1 flex-center">
          {render_buttons_settings()}
          <LABEL__workspace_balance />
        </div>

        <HARDWARE_STATS__master />
      </div>
    </LAYOUT_COLUMN__right>
  );
}
